import { render, staticRenderFns } from "./ModifyProductInBox.vue?vue&type=template&id=a1961942&"
import script from "./ModifyProductInBox.vue?vue&type=script&lang=js&"
export * from "./ModifyProductInBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports